export default __webpack_public_path__ + "static/media/SansWeb-BoldItalic.090f33cb.woff";